import React from "react";
import { Product as TProduct } from "@core/types";
import classNames from "classnames/bind";
import styles from "./ProductDescription.module.scss";
import { useTranslation } from "react-i18next";

interface IProductDescriptionProps {
  props: Pick<TProduct, "description">;
}

const cx = classNames.bind(styles);

function createMarkupDesc(description: IProductDescriptionProps["props"]["description"]) {
  return { __html: String(description) };
}

const ProductDescription = ({ props }: IProductDescriptionProps) => {
  const { t } = useTranslation();
  return !!props?.description ? (
    <div className={cx("detailDescription")} dangerouslySetInnerHTML={createMarkupDesc(props?.description)}></div>
  ) : (
    <div className={cx("detailDescription")}>{t("No description")}</div>
  );
};

export { ProductDescription };
